import { MAX_SCROLL_KEYS } from './ScrollRestoration.constants';
import { ScrollPositions } from './ScrollRestoration.types';

/** Ограничиваем количество хранимых позиций скролла для роутов */
export function prunePositions(positions: ScrollPositions) {
    // Если лимит не превышен, ничего не делаем
    const keys = Object.keys(positions);
    if (keys.length <= MAX_SCROLL_KEYS) {
        return positions;
    }

    // Удаляем самые старые (по порядку появления в объекте)
    const newPositions: ScrollPositions = {};
    keys.slice(keys.length - MAX_SCROLL_KEYS).forEach(k => {
        newPositions[k] = positions[k];
    });

    return newPositions;
}
